<template>
  <common-page-table
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="titleName"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :keyTable="'receiverSystemId'"
    :deleteParams="deleteParams"
    :apiDeleteName="apiDeleteName"
    :alternativeConverter="convertData"
    :isDefaultConverter="false"
    :forceIsEdit="true"
    :forceIsCreate="false"
    :forceDelete="true"
    :showSearch="showSearch"
    :link-create="linkCreate"
    :convert-delete-body="convertDeleteBody"
    :do-convert-delete="true"
    :prefixEdit="prefixEdit"
    :prefixShow="prefixShow"
    :extraQuery="extraQuery"
  >
    <slot/>
  </common-page-table>
</template>
<script>
import {NAME_OBJECT} from "@/RoleConstanans";
import CommonPageTable from "../../../commonElement/CommonPageTable.vue";
import {API_METHODS} from "@/constant";
import convertLangDataToTable from "@/helpers/converters/convertLangDataToTable";

export default {
  name: "ReceiverSystemTable",
  components: {CommonPageTable},
  props: {
    linkCreate: {type: String, default: ""},
    showSearch: {type: Boolean, default: true},
    apiName: {type: String, default: API_METHODS.GET_ALL_USER_RECEIVER_SYSTEM},
    apiDeleteName: {type: String, default: API_METHODS.DELETE_USER_RECEIVER_SYSTEM},
    paramsGetData: {type: Object, default: () => ({})},
    prefixEdit: { type: String, default: null },
    prefixShow: { type: String, default: null },
  },
  data() {
    return {
      fieldLang: "",
    };
  },
  computed: {
    extraQuery(){
      return {
        user_id: Number(this.userId),
        back: 'user'
      }
    },
    userId() {
      return this.$route.params?.UserId ?? null;
    },

    titleName() {
      return this.$t('ReceiverSystem');
    },

    nameRoleEntity() {
      return NAME_OBJECT.ReceiverSystems;
    }
  },

  methods: {
    convertData(dataNow, langNow) {
      return convertLangDataToTable(dataNow, langNow, "", false);
    },
    deleteParams(id) {
      return {id: id};
    },

    convertDeleteBody(id) {
      if (!this.userId) {
        return {id: id};
      }
      return {
        userId: Number(this.userId),
        receiverSystem: {
          receiverSystemId: id,
        }
      }
    }
  }
};
</script>
